import LocalLandlordAdvisory from './LocalLandlordAdvisory';

export default LocalLandlordAdvisory;
